export default __webpack_public_path__ + "static/media/Lincoln Heritage dark.4beaa974.svg";